module.exports = __webpack_public_path__ + "img/icon-balancepay.484ecd41.svg";